<ng-container [formGroup]="checkboxGroup">
  @if (label) {
  <label class="col-form-label">{{ label | globalTranslate }}</label>
  }
  <div class="mb-2">
    @for (checkbox of checkboxList; track checkbox; let i = $index) {
    <demographics-checkbox
      [checkboxValue]="getCheckboxValue(checkbox.reference, checkbox.control)"
      [disabled]="isCheckboxDisabled(checkbox.reference)"
      (valueChange)="setFromList($event)"
      [inline]="inline"
      [control]="checkboxGroup.get(checkbox.control)"
      [checkedValue]="checkbox.reference"
      [label]="checkbox.reference.value"
      [name]="checkbox.control"
      [index]="i"
    >
    </demographics-checkbox>
    }
  </div>
</ng-container>
